import React from "react";
import { Button } from "reactstrap";

const CreateFamilyFooter = props => (
  <Button
    style={{ paddingLeft: "100px", paddingRight: "100px", margin: 0 }}
    color="info"
    data-dismiss="modal"
    type="button"
    onClick={props.onConfirm}
  >
    Salvar Família
  </Button>
);

export default CreateFamilyFooter;
